export default __webpack_public_path__ + "media/images/to-app-store-100-72885f291573aa217e445595957eefc9.png";